import { render, staticRenderFns } from "./postWarningDetail.vue?vue&type=template&id=12b729de&scoped=true&"
import script from "./postWarningDetail.vue?vue&type=script&lang=js&"
export * from "./postWarningDetail.vue?vue&type=script&lang=js&"
import style1 from "./postWarningDetail.vue?vue&type=style&index=1&id=12b729de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b729de",
  null
  
)

export default component.exports